<template>
  <div>
    <div ref="banner" class="banner-img">
      <div class="title">
        <div>PEOPLE</div>
        <div class="subtitle">实验室成员</div>
      </div>
      <img src="../assets/banner-people.png">
    </div>
    <div class="menu-box" :class="{'menu-fixed':menuFixed}">
      <div class="content-box menu">
        <div
          v-for="item in showTypes"
          :key="item.id"
          class="menu-item"
          :class="{'menu-active':item.id===activeId}"
          @click="menuClick(item)"
        >
          {{ item.shortName }}
          <div class="underline" />
        </div>
      </div>
    </div>
    <div class="content-box">
      <PIBox v-if="pi" id="p-menu1" :title="mapType(1).name" :list="pi" :icon="require('@/assets/icons/people_principal.png')" />
      <PIBox v-if="admin" id="p-menu2" :title="mapType(2).name" :list="admin" :icon="require('@/assets/icons/people_admin.png')" img-width="21%" style="padding-bottom: 12px" />
      <StuBox v-for="(item,index) in students" :id="'p-menu'+item.list[0].type" :key="item.name" :title="item.name" :list="item.list" :icon="icons[index]" />
    </div>
  </div>
</template>

<script>
import PIBox from '@/components/people/PIBox.vue'
import StuBox from '@/components/people/StuBox.vue'

export default {
  name: 'People',
  components: {
    PIBox,
    StuBox
  },
  data() {
    return {
      menuFixed: false,
      types: [],
      activeId: 1,
      people: {},
      icons: [
        require('@/assets/icons/people_postdocs.png'),
        require('@/assets/icons/people_graduate.png'),
        require('@/assets/icons/people_undergraduate.png')
      ]
    }
  },
  computed: {
    showTypes() {
      return this.types.filter(item => item.shortName)
    },
    pi() {
      return this.people[1]
    },
    admin() {
      return this.people[2]
    },
    students() {
      const data = []
      this.types.filter(item => [1, 2].indexOf(item.id) < 0).forEach(type => {
        const tmp = this.people[type.id]
        if (tmp) {
          data.push({
            name: type.name,
            list: tmp
          })
        }
      })
      return data
    }
  },
  created() {
    this.$axios.get(this.$api.getPeopleTypes).then(res => {
      this.types = res.data
    })
    this.$axios.get(this.$api.listPeople).then(res => {
      this.people = res.data
    })
  },
  mounted() {
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll)
  },
  beforeDestroy() {
    // 离开该页面需要移除这个监听的事件，不然会报错  必须带第三个参数true，否则销毁不成功
    window.removeEventListener('scroll', this.watchScroll)
  },
  methods: {
    menuClick(item) {
      let offsetTop = document.getElementById('p-menu' + item.id).offsetTop
      if (!this.menuFixed) {
        offsetTop -= 120
      }
      document.documentElement.scrollTop = offsetTop - 120
      this.activeId = item.id
    },
    mapType(id) {
      return this.types.filter(item => item.id === id)[0]
    },
    watchScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const bannerHeight = this.$refs.banner.offsetHeight
      this.menuFixed = scrollTop > 110 + bannerHeight
    }
  }
}
</script>

<style lang="stylus" scoped>
.menu-box
  width 100%
  background linear-gradient(162deg, rgba(77, 97, 161, 1) 0%, rgba(39, 55, 94, 1) 100%, rgba(48, 64, 91, 1) 100%)

  .menu
    display flex
    justify-content space-between
    font-size 18px
    font-weight 500
    color rgba(166, 180, 224, 1)
    height 120px
    line-height 120px

    .menu-item
      cursor pointer
      position relative
      flex 1
      text-align center

    .menu-active
      color white
      font-weight 600

      .underline
        width 100%
        background white
        height 5px
        position absolute
        bottom 0
</style>
